import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { decrypt } from "@/assets/utils/cryptoUtil";
export function picFilter(val) {
  if (val.picturePath != null && window.g.VUE_APP_IMGURL != undefined) {
    return window.g.VUE_APP_IMGURL + val.picturePath;
  } else {
    if (val.packageName.includes('学生')) {
      return require("@/assets/images/package/package-student.svg");
    }

    if (val.packageName.includes('幼儿') || val.packageName.includes('小孩') || val.packageName.includes('宝宝')) {
      return require("@/assets/images/package/package-baby.svg");
    }

    if (val.sexId == '1') {
      if (val.packageName.includes('老年') || val.packageName.includes('老人') || val.packageName.includes('高龄')) {
        return require("@/assets/images/package/package-man-old.svg");
      }

      if (val.packageName.includes('入职') || val.packageName.includes('招工') || val.packageName.includes('单位')) {
        return require("@/assets/images/package/package-man-work.svg");
      }

      if (val.packageName.includes('精英')) {
        return require("@/assets/images/package/package-man-work.svg");
      }

      return require("@/assets/images/package/package-man.jpg");
    } else if (val.sexId == '2') {
      if (val.packageName.includes('老年') || val.packageName.includes('老人') || val.packageName.includes('高龄')) {
        return require("@/assets/images/package/package-woman-old.svg");
      }

      if (val.packageName.includes('入职') || val.packageName.includes('招工') || val.packageName.includes('单位')) {
        return require("@/assets/images/package/package-woman-work.svg");
      }

      return require("@/assets/images/package/package-woman.jpg");
    } else {
      if (val.packageName.includes('老年') || val.packageName.includes('老人') || val.packageName.includes('高龄')) {
        return require("@/assets/images/package/package-default-old.svg");
      }

      if (val.packageName.includes('入职') || val.packageName.includes('招工') || val.packageName.includes('单位')) {
        return require("@/assets/images/package/package-default-work.svg");
      }

      return require("@/assets/images/package/package-default.jpg");
    }
  }
} //解密显示

export function decryptFilter(value) {
  return decrypt(value);
}